import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { ConfigService } from './utility/services/common/config.service';
import { LstorageService } from './utility/services/common/lstorage.service';
import { LSkeys } from './utility/configs/app.constants';
import { Router } from '@angular/router';
import { ROUTE_CONFIGS } from './utility/configs/routerConfig';
import { LoaderService } from './utility/services/common/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  initailLoading: boolean = true;
  isScrolled = false;
  isLoader: boolean = false;
  constructor(
    private configServ: ConfigService,
    private LstorageServ: LstorageService,
    private router: Router,
    private loaderServ: LoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.configServ.initApp().subscribe(res => {
      setTimeout(() => {
        this.initailLoading = res
      }, 500);
    })
  }

  // Listen to scroll events on window
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    if (scrollPosition > totalHeight * 0.05) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }
  ngOnInit(): void {

    this.loaderServ.getLoaderStatus().subscribe((status) => {
      this.isLoader = status;
      this.cdr.detectChanges();
    });
    if(!this.LstorageServ.getItem(LSkeys.LANGUAGE_ID)){
      this.LstorageServ.store(LSkeys.LANGUAGE_ID,'1')
    }
    const accountStep = this.LstorageServ.getItem(LSkeys.ACCOUNT_STEP);

    if (accountStep) {
      if (accountStep === '1') {
        this.router.navigate([ROUTE_CONFIGS.CUSTOMER_PROFILE_ROUTE]);
      } else if (accountStep === '2') {
        this.router.navigate([ROUTE_CONFIGS.CUSTOMER_BOOKING_ROUTE]);
      }
    }

  }
}
